import React from "react"
import styled from "styled-components"
import Layout from "../components/layout/layout"
import media from "styled-media-query"
import SEO from "../components/seo"

const Contact = props => {
  const handleSubmit = async (e) => {
    e.preventDefault()
    const form = e.target
    const payload = {
      name: form["Name"].value,
      email: form["Email"].value,
      message: form["Message"].value,
    }

    try {
      const res = await fetch("https://api.flamingosoftware.co.uk/showstopwatch/get-in-contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })

      if (res.ok) {
        alert("Message sent!")
        form.reset()
      } else {
        alert("Something went wrong. Please try again.")
      }
    } catch (err) {
      console.log(err)
      alert("Network error. Please try again.")
    }
  }

  return (
    <>
      <SEO title="Get in Contact" description="Im always excited to hear what people have to say!" />
      <Layout>
        <Container>
          <h1>Get in Contact</h1>
          <h3>
            I always love to hear ways to improve Show StopWatch or bugs that I
            have missed — so please get in touch.
          </h3>
          <Form onSubmit={handleSubmit}>
<InputField label="Name" type="text" placeholder="Your name" required autoComplete="name" />

            <InputField label="Email" type="email" placeholder="your@email.com" required />
            <Label fullWidth>
              Message
              <textarea
                name="Message"
                id="message"
                required
                rows="5"
                placeholder="Let me know how I can help"
              />
            </Label>
            <ButtonRow>
              <Button type="submit">Send</Button>
            </ButtonRow>
          </Form>
        </Container>
      </Layout>
    </>
  )
}

export default Contact

const InputField = ({ label, type, placeholder, required }) => (
  <Label>
    <div>
      {label}
      {!required && <Optional> - optional</Optional>}
    </div>
    <Input
      type={type}
      name={label}
      placeholder={placeholder}
      required={required}
    />
  </Label>
)

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  min-height: 85vh;
  padding: 2em 1em;

  a { color: #c084fc; }
  p { max-width: 500px; }

  ${media.greaterThan("large")`
    max-width: 750px;
    min-height: 700px;
  `};

  h1 {
    color: #ffffff;
    font-size: 2.4rem;
    text-align: center;
    margin-bottom: 0.4em;
    letter-spacing: -0.5px;
  }

  h3 {
    color: rgba(255, 255, 255, 0.6);
    font-weight: 300;
    font-size: 1rem;
    text-align: center;
    max-width: 420px;
    line-height: 1.6;
    margin-bottom: 2em;
    padding: 0 1em;
  }
`

const Form = styled.form`
  background: linear-gradient(160deg, rgba(80,10,120,0.6) 0%, rgba(30,2,50,0.8) 100%);
  backdrop-filter: blur(10px);
  padding: 2em;
  border-radius: 20px;
  width: 80%;
  box-shadow: 0 8px 32px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.08);
  border: 1px solid rgba(142, 59, 200, 0.3);

  ${media.greaterThan("large")`
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    gap: 0 4%;
  `};

  textarea {
    resize: vertical;
    margin-top: 6px;
    font-weight: normal;
    width: 100%;
    display: inline-block;
    line-height: 1.3;
    box-sizing: border-box;
    color: white;
    background-color: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(142, 59, 200, 0.4);
    outline: none;
    padding: 14px 20px;
    border-radius: 8px;
    font-family: inherit;
    transition: border-color 0.2s ease;

    &:focus {
      border-color: rgba(142, 59, 200, 0.9);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.8);
    }
  }
`

const Label = styled.label`
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding-bottom: 16px;
  color: rgba(255, 255, 255, 0.75);

  ${media.greaterThan("large")`
    margin-bottom: 0;
    flex-basis: ${p => (p.fullWidth ? "100" : "46")}%;
    margin-right: 4%;
  `};
`

const Input = styled.input`
  margin-top: 6px;
  font-weight: normal;
  display: block;
  width: 100%;
  box-sizing: border-box;
  color: white;
  background-color: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(142, 59, 200, 0.4);
  outline: none;
  padding: 14px 20px;
  border-radius: 8px;
  font-family: inherit;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: rgba(142, 59, 200, 0.9);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.8);
  }
`

const ButtonRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const Button = styled.button`
  font-weight: bold;
  font-size: 18px;
  line-height: 48px;
  height: 50px;
  background: linear-gradient(90deg, rgba(64,5,87,1) 0%, rgba(142,59,200,1) 100%);
  color: white;
  text-align: center;
  cursor: pointer;
  border: 1px solid rgba(142, 59, 200, 0.6);
  outline: none;
  padding: 0px 32px;
  border-radius: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 15px rgba(142, 59, 200, 0.3);

  &:hover {
    background: linear-gradient(90deg, rgba(80,10,110,1) 0%, rgba(170,80,230,1) 100%);
    box-shadow: 0 4px 20px rgba(142, 59, 200, 0.6);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  width: 100%;
  ${media.greaterThan("large")`
    width: unset;
  `};
`

const Optional = styled.span`
  font-size: 0.75rem;
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  margin-left: 4px;
  color: rgba(255, 255, 255, 0.35);
`